import { z } from "zod";

export const schema = z.object({
	id_conta_tipo: z.number().int("Campo id_empresa é obrigatorio"),
	id_funcionario: z.number().int("Campo id_funcionario é obrigatorio"),
	nome: z.string().min(1, "Descrição do centro custo é obrigatório"),
	codigo: z.string().nullable(),
	ativo: z.boolean(),
	obs: z.string().nullable(),
	tipo: z.string().nullable(),
});

// Defina os valores padrão aqui
export const schemaDefaultValues = {
	id_conta_tipo: 0,
	id_funcionario: 1,
	nome: "",
	codigo: "",
	ativo: true,
	obs: "",
	tipo: "T",
};
